import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import clickShowTag from '@/components/clickShowTag.vue';
import tagModel from '@/components/tagModel.vue';
import tagList from '@/components/tagList.vue';
import { unitResource } from './../../insurance/underwritingManage/request';
import { agencyResource } from './../../insurance/organizationalManage/request';
import { customerResource } from './../../system/customerManage/request';
import { applicationResource } from './../../customer/applicationManage/request';
import { structureList } from './../../customer/accountManage/request';
import { downloadPolicy, policyList, policyZip, getTags } from './request';
import { downloadFileFun, LANGUAGE_RESOURCE } from '@/utils/public';
import { insuranceResource, getArea } from './../../insurance/insuranceManage/request';
import { PAYSTATUS } from '@/views/order/homeManage/request';
import selectShowColumn from '../customerManage/selectShowColumn.vue';
import moment from 'moment';
import datePicker from '@/components/datePicker.vue';
import refundModal from './refundModal.vue';
export default {
  components: {
    clickShowTag,
    tagModel,
    tagList,
    selectShowColumn,
    datePicker,
    refundModal
  },
  data() {
    return {
      PAYSTATUS,
      tagShow: false,
      showItem: false,
      refundVisible: false,
      form: {
        createAt: '',
        agencyId: undefined,
        structureId: undefined,
        applicationId: undefined,
        customerId: undefined,
        tags: '',
        content: '',
        insuranceId: undefined
      },
      unitList: [],
      intermediaryList: [],
      customerList: [],
      customerList2: [],
      applicationList: [],
      issuingList: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      data: [],
      columns: [],
      tagData: [],
      tagList: [],
      productList: [],
      rearOptions: [],
      areaValue: [],
      applicationTime: []
    };
  },
  created() {
    unitResource({}).then(res => {
      this.unitList = res;
    });
    this.agencyFun();
    // customerResource({isLicense:1}).then(res=>{
    //   this.customerList=res;
    // });
    this.getAreaOptions();
    customerResource({}).then(res => {
      this.customerList2 = res;
      if (res.length == 0) {
        return false;
      }
      let arr = res.filter(item => item.id == Number(sessionStorage.getItem('policyCustomerId')));
      this.form.customerId = arr.length != 0 ? Number(sessionStorage.getItem('policyCustomerId')) : res[0].id;
      sessionStorage.setItem('policyCustomerId', this.form.customerId);
      this.getTagsFun();
      this.getDataFun();
      this.applicationFun();
    });
  },
  methods: {
    isShowMore(record) {
      let isShowMore = false;
      if (record.recordMethod == 1 && this.isAuth('home.policyEdit')) {
        //编辑按钮是否显示
        isShowMore = true;
      }
      if (this.isAuth('home.policyZip')) {
        // 下载保单按钮
        isShowMore = true;
      }
      if (this.isAuth('home.personnelDetailsList')) {
        //人员明细按钮
        isShowMore = true;
      }
      if (this.isAuth('home.correctRecordList')) {
        //批改记录按钮
        isShowMore = true;
      }
      return isShowMore;
    },
    getAreaOptions() {
      getArea({}).then(res => {
        let loop = data => {
          if (!Array.isArray(data)) return [];
          return data.map(item => {
            if (item.child) {
              item.children = loop(item.child);
            }
            item.label = item.name;
            item.value = item.code;
            return item;
          });
        };
        this.rearOptions = loop(res);
      });
    },
    getInsuranceFun() {
      this.productList = [];
      this.form.insuranceId = undefined;
      if (!this.form.applicationId) {
        return false;
      }
      insuranceResource({
        applicationId: this.form.applicationId,
        customerId: this.form.customerId
      }).then(res => {
        this.productList = res;
      });
    },
    getTagsFun() {
      getTags({
        customerId: this.form.customerId
      }).then(res => {
        this.tagData = res;
      });
    },
    getDataFun() {
      const h = this.$createElement;
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      obj.createAt = this.applicationTime[0] ? moment(this.applicationTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
      obj.endAt = this.applicationTime[1] ? moment(this.applicationTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
      policyList(obj).then(res => {
        if (res.fieldConfig) {
          this.columns = res.fieldConfig.map(item => {
            let obj = item;
            if (item.ellipsis) {
              obj.customRender = text => h("a-tooltip", {
                "attrs": {
                  "placement": "topLeft",
                  "title": text
                }
              }, [text]);
            }
            if (item.dataIndex === 'payStatusName' || item.dataIndex === 'isTimely' || item.dataIndex === 'status') {
              item.customRender = (text, record) => {
                return h("span", [this.$t(text)]);
              };
            }
            if (item.dataIndex === 'tag') {
              obj.scopedSlots = {
                customRender: 'tag'
              };
            }
            return obj;
          });
          this.columns = this.columns.filter(item => item.dataIndex !== 'operate');
          this.columns.push({
            // title: '操作',
            scopedSlots: {
              customRender: 'action',
              title: 'customTitle'
            },
            align: 'center',
            class: 'column-action',
            key: 'column-action',
            width: 250
          });
        }
        this.pagination.total = res.totalNum;
        this.data = res.items;
      });
    },
    onChange(date, dateString) {
      this.form.createAt = dateString;
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    agencyFun() {
      this.form.agencyId = undefined;
      agencyResource({
        unitId: this.form.unitId
      }).then(res => {
        this.intermediaryList = res;
      });
    },
    agencyChange(val) {
      let arr = this.intermediaryList.filter(item => item.id == val);
      this.form.unitId = arr.length != 0 ? arr[0].unitId : undefined;
      if (!this.form.unitId) {
        this.agencyFun();
      }
    },
    applicationFun() {
      this.form.applicationId = undefined;
      this.form.insuranceId = undefined;
      applicationResource({
        customerId: this.form.customerId
      }).then(res => {
        this.applicationList = res;
      });
    },
    applicationChange(val) {
      let arr = this.applicationList.filter(item => item.id == val);
      this.form.licenseId = arr.length != 0 ? arr[0].customerId : undefined;
      this.getInsuranceFun();
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    downloadFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      const language = sessionStorage.getItem('locale') || 'zh_CN';
      obj.language = LANGUAGE_RESOURCE[language];
      downloadPolicy(obj).then(res => {
        let nowDate = new Date();
        let time = nowDate.getFullYear() + '-' + Number(Number(nowDate.getMonth()) + 1) + '-' + nowDate.getDate();
        downloadFileFun(res, 'application/vnd.ms-excel', this.$t('保单列表') + time + '.xlsx');
      });
    },
    issuingChange() {
      this.issuingList = [];
      this.form.structureId = undefined;
      if (!this.form.customerId) {
        return false;
      }
      structureList({
        customerId: this.form.customerId
      }).then(res => {
        this.issuingList = res;
        this.form.structureId = res[0].id;
      });
      sessionStorage.setItem('policyCustomerId', this.form.customerId);
      this.tagData = [];
      this.tagList = [];
      this.getTagsFun();
      this.searchFun();
      this.applicationFun();
    },
    async handleDownload(val) {
      const res = await policyZip({
        policyId: val.policyId
      });
      downloadFileFun(res, 'application/zip', val.policyNo + this.$t('电子保单') + '.zip');
    },
    tagOk(arr, arr2, arrVaule) {
      this.form.tags = arrVaule;
      this.tagList = arr;
      if (arr2.length != 0) {
        this.tagList.push(arr2);
      }
      this.searchFun();
    },
    tagListOk(arr, arr2, arrVaule) {
      this.tagData = arr;
      this.tagList = arr2;
      this.form.tags = arrVaule;
      this.searchFun();
    },
    filterOption2(input, option) {
      return option.componentOptions.children[0].componentOptions.propsData.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    resetFun() {
      this.tagList = [];
      this.tagShow = false;
      this.tagData = this.tagData.map(item => {
        if (item.children && item.children.length) {
          item.children = item.children.map(child => {
            delete child.choice;
            return child;
          });
          return item;
        }
      });
      this.applicationTime = [];
      this.$refs.applicationTime && this.$refs.applicationTime.resetData();
      this.areaValue = [];
      this.form = {
        createAt: '',
        agencyId: undefined,
        structureId: undefined,
        applicationId: undefined,
        customerId: this.form.customerId,
        tags: '',
        insuranceId: undefined,
        content: ''
      };
    },
    areaChange(value) {
      if (value && value.length) {
        let areaCode = value[value.length - 1];
        this.$set(this.form, 'areaCode', areaCode);
      } else {
        this.$set(this.form, 'areaCode', undefined);
      }
    },
    settingColumn() {
      this.$refs.selectShowColumn.openModal();
    },
    onChangeTime(date) {
      this.applicationTime = date;
    },
    toPersonnelDetail(record) {
      this.$router.push({
        name: 'homePersonnelDetail',
        params: {
          id: record.policyId
        }
      });
    },
    toCorrectionRecord(record) {
      if (!record.customerInsuranceDeclarationMethod) {
        this.$message.error(this.$t('请联系管理员配置申报方式'));
        return;
      }
      this.$router.push({
        name: 'homeCorrectionRecord',
        params: {
          id: record.policyId
        }
      });
    },
    onRefund(record) {
      this.refundVisible = true;
      this.$nextTick(() => {
        this.$refs.refundFrom.init(record.customerId, record.policyId);
      });
    },
    isRefund(record) {
      if (record.recordMethod === 0 || record.status === 2) {
        if (record.status == '待生效' || record.status == '退保失败') {
          return true;
        }
        if (record.status == '待投保' && record.payStatusName == '已支付') {
          return true;
        }
      }
      return false;
    }
  }
};